/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {useFleetUpdateFetchingStatus} from './useFleetUpdateFetchingStatus';
import {useFleetUpdates} from './useFleetUpdates';

/**
 * useTrackedFleetUpdate combines the two-hook pairing every tracking2
 * auto-refresh consumer repeats at its call site - wrapping a consumer's
 * own refetch so the shared registry sees it start and finish, then wiring
 * that tracked refetch up to the shared `fleetUpdateFlag` pulse - into a
 * single call.
 *
 * ```typescript
 *
 *   import {useTrackedFleetUpdate} from
 *     '@/routes/tracking2/hooks/useTrackedFleetUpdate';
 *   ...
 *
 *   useTrackedFleetUpdate('geofence', refetch, loading);
 *
 * ```
 *
 * @param key       - The stable literal id identifying this consumer.
 * @param refetchFn - The consumer's own refetch function to track and run.
 * @param isLoading - Suppresses the refresh while the consumer is loading.
 */
export const useTrackedFleetUpdate = (key: string, refetchFn: Function, isLoading: boolean): void => {
  const trackedRefetch = useFleetUpdateFetchingStatus(key, refetchFn);
  useFleetUpdates(trackedRefetch, isLoading);
};

export default useTrackedFleetUpdate;
